if (!customElements.get('innova-fbt-carousel')) {
  customElements.define('innova-fbt-carousel', class InnovaFbtCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.track = this.querySelector('[data-innova-fbt-track]');
      this.previousButton = this.querySelector('[data-innova-fbt-previous]');
      this.nextButton = this.querySelector('[data-innova-fbt-next]');
      this.progress = this.querySelector('[data-innova-fbt-progress]');
      this.progressFill = this.querySelector('[data-innova-fbt-progress-fill]');

      if (!this.track) return;

      this.previousButton?.addEventListener('click', () => this.scrollByColumn(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByColumn(1));
      this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });
      this.track.addEventListener('keydown', (event) => this.onKeydown(event));
      this.addEventListener('change', (event) => this.onSelectionChange(event));

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
        this.resizeObserver.observe(this.track);
      }

      this.querySelectorAll('[data-innova-fbt-checkbox]').forEach((checkbox) => {
        this.updateCardState(checkbox);
      });

      this.requestUpdate();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    getScrollAmount() {
      const card = this.track.querySelector('[data-innova-fbt-card]');
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);

      return card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * .45;
    }

    scrollByColumn(direction) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollBy({
        left: this.getScrollAmount() * direction,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    }

    onKeydown(event) {
      if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;

      event.preventDefault();
      this.scrollByColumn(event.key === 'ArrowRight' ? 1 : -1);
    }

    onSelectionChange(event) {
      if (!event.target.matches('[data-innova-fbt-checkbox]')) return;

      this.updateCardState(event.target);
    }

    updateCardState(checkbox) {
      checkbox.closest('[data-innova-fbt-card]')?.classList.toggle('is-selected', checkbox.checked);
    }

    requestUpdate() {
      cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.updateNavigation());
    }

    updateNavigation() {
      const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const currentScroll = Math.max(0, this.track.scrollLeft);
      const atStart = currentScroll <= 3;
      const atEnd = maximumScroll <= 3 || currentScroll >= maximumScroll - 3;
      const viewedPercent = maximumScroll <= 3
        ? 100
        : Math.min(100, ((currentScroll + this.track.clientWidth) / this.track.scrollWidth) * 100);

      if (this.previousButton) this.previousButton.disabled = atStart;
      if (this.nextButton) this.nextButton.disabled = atEnd;
      if (this.progressFill) this.progressFill.style.width = `${viewedPercent}%`;
      if (this.progress) this.progress.setAttribute('aria-valuenow', String(Math.round(viewedPercent)));
    }
  });
}
